import React, { useRef } from 'react';
import { Editor as TinymceEditor } from '@tinymce/tinymce-react';
import { FormControl } from '@mui/material';
import ElementUtils from '../../utils';
import { EditorProps } from '../types';
import {
  createImageFilePickerCallback,
  emailEditorImageConfig,
} from '../imageUpload';

function EditorClassic(props: EditorProps) {
  const {
    onChange,
    value,
    error,
    label,
    disabled,
    height,
    placeholder,
  } = props;
  const editorRef = useRef<TinymceEditor>(null);

  return (
    <FormControl className="w-full h-full" component="fieldset" variant="standard">
      {label && <div>{label}</div>}
      <TinymceEditor
        ref={editorRef}
        disabled={disabled}
        tinymceScriptSrc={`${process.env.PUBLIC_URL}/tinymce/tinymce.min.js`}
        value={value}
        onEditorChange={(e) => {
          if (onChange) {
            onChange(e, editorRef.current?.editor?.isDirty());
          }
        }}
        init={{
          height,
          placeholder: placeholder || 'Type here...',
          menubar: false,
          branding: false,
          convert_urls: false,
          elementpath: false,
          ...emailEditorImageConfig,
          file_picker_callback: createImageFilePickerCallback(
            () => editorRef.current?.editor,
          ),
          plugins: [
            'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
            'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
            'insertdatetime', 'media', 'table', 'code', 'wordcount',
          ],
          toolbar: 'undo redo | blocks | '
            + 'bold italic forecolor | alignleft aligncenter '
            + 'alignright alignjustify | bullist numlist outdent indent | image',
          content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
        }}
      />
      {error && (
        <div className="absolute -bottom-5 text-error text-xs">
          {ElementUtils.renderError(error)}
        </div>
      )}
    </FormControl>
  );
}

EditorClassic.defaultProps = {
  onChange: () => { },
  disabled: false,
  height: undefined,
  placeholder: '',
};

EditorClassic.propTypes = {};

export default EditorClassic;
